import type { PlanetUpgradeDef } from '@playnets/sim';

/**
 * PLANET UPGRADES
 *
 * You don't only build defences — you build the planet. These are bought with
 * juice during a build phase and reset every run, so "reinforce the hull or put
 * it all into guns?" is a live decision on every level rather than something
 * settled once in a meta screen and never thought about again.
 *
 * Costs escalate steeply. Taking a fourth level of anything should mean going
 * without a whole structure.
 */
export const PLANET_UPGRADES: readonly PlanetUpgradeDef[] = [
  {
    id: 'hull',
    name: 'Reinforced Hull',
    text: '+30 Core Integrity, healed on purchase.',
    costs: [8, 13, 19, 27],
  },
  {
    id: 'magnet',
    name: 'Magnetics',
    text: 'Juice landing near the crust collects itself.',
    costs: [7, 11, 16],
  },
  {
    id: 'mint',
    name: 'Mint',
    text: '+1 juice on every drop you pick up.',
    costs: [9, 14, 21],
  },
  {
    id: 'servos',
    name: 'Servos',
    text: '+15% ring rotation speed.',
    costs: [7, 12, 17],
  },
  {
    id: 'crust-mounts',
    name: 'Crust Mount',
    text: 'One more surface mount. The crust respaces to fit.',
    costs: [13, 22],
  },
  {
    id: 'orbit-mounts',
    name: 'Orbit Mount',
    text: 'One more ring mount. The ring respaces to fit.',
    costs: [15, 25],
  },
];
